import { Component, OnInit, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { RouterModule } from '@angular/router';
import { HeaderComponent } from '../../components/header/header.component';
import { FooterComponent } from '../../components/footer/footer.component';
import { AuthServiceService } from '@services/auth-service.service';
import { Globals } from 'src/app/globals';
import { RegUser } from '../basic-reg/RegUser';

@Component({
  selector: 'app-government',
  standalone: true,
  templateUrl: './government.component.html',
  styleUrls: ['./government.component.scss'],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    HeaderComponent,
    FooterComponent
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA]
})
export class GovernmentComponent implements OnInit {

  user: RegUser = new RegUser();
  LoggedIn: boolean = false;

  constructor(private authService: AuthServiceService, public global: Globals) { }

  ngOnInit(): void {
    this.user = this.authService.getLoggedInUser();
  }

  ionViewWillEnter() {
    this.user = this.authService.getLoggedInUser();
    this.LoggedIn = this.authService.isLoggedIn();
    if (!this.global.isEmpty(this.user)) {
      this.user.imageUrl = this.authService.getProfilePicture() as string;
    }
  }

}

